const Colors = {
  // font color
  orange: "#FF9200",
  green: "#5E9100",
  black: "#1c1c1c",
  lightBlack: "#343434",
  white: "#ffffff",
  grey: "#717576",
  blue: "#1f9ee1",
  lightGrey: "#f9f9f9",
  darkGrey: "#5A5A5A",
  red: "#D0021B",
  // bg color
  lightwhite: "#F1F1F1",
  darkwhite: "#E1E1E1",
  lightGreen: "#ACFF4B",
  darkGreen: "#417505",
  cyan: "#14D18F",
  lightBlue: "#4A90E2",
  darkBlue: "#4464A1",
  sky: "#50AFC5",
  lightYellow: "#DBFF00"
}

const Size = {
  // 1rem = 16px base
  size10: "0.625rem",
  size11: "0.688rem",
  size12: "0.75rem",
  size14: "0.875rem",
  size15: "0.9375rem",
  size16: "1rem",
  size18: "1.125rem",
  size20: "1.25rem",
  size22: "1.375rem",
  size26: "1.625rem",
  size36: "2.25rem",
  size40: "2.5rem"
}

const FontFamily = {
  // 1rem = 16px base
  arial: "Arial, sans-serif",
  roboto: "Roboto, Arial, sans-serif"
}

const FontWeight = {
  fw100: "100",
  fw300: "300",
  fw400: "400",
  fw500: "500",
  fw600: "600",
  fw700: "700",
  fw800: "800",
  fw900: "900",
  fw1000: "1000",
}


export { Colors, Size, FontFamily, FontWeight }
